import { blue, grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { breakdownGridRowIdKey } from "./data";

export const BREAKDOWN_GRID_ROW_HEIGHT = 52;
export const BREAKDOWN_GRID_HEADER_HEIGHT = 35;

export const getBreakdownGridHeight = (rowCount) =>
	Math.min(Math.max(rowCount * BREAKDOWN_GRID_ROW_HEIGHT + 40, 200), 520);

export const getBreakdownDataGridSx = (rowCount) => ({
	width: "100%",
	maxWidth: "100%",
	height: getBreakdownGridHeight(rowCount),
	background: "#fff",
	border: "none",
	overflowX: "auto",
	"& .MuiDataGrid-main": { overflowX: "auto" },
	"& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" },
	"& .MuiDataGrid-row": {
		cursor: "pointer",
		backgroundColor: "#fff",
		transition: "background-color 0.15s ease",
		"&:nth-of-type(even)": { backgroundColor: grey[50] },
	},
	"& .MuiDataGrid-columnHeader": {
		cursor: "default",
		backgroundColor: grey[50],
		borderBottom: `1px solid ${grey[200]}`,
	},
	"& .MuiDataGrid-cell": {
		padding: 0,
		borderBottom: `1px solid ${grey[100]}`,
		borderRight: `1px solid ${grey[100]}`,
	},
	"& .MuiDataGrid-cell:focus-within": {
		outline: `2px solid ${blue[200]}`,
		outlineOffset: "-2px",
	},
	"& .MuiDataGrid-columnHeaders": {
		background: grey[50],
		borderBottom: `1px solid ${grey[200]}`,
		borderRadius: 0,
	},
	"& .MuiDataGrid-columnHeaderTitleContainer": { overflow: "hidden" },
	"& .MuiDataGrid-cellContent": { overflow: "hidden", textOverflow: "ellipsis" },
});

const BreakdownDataGrid = ({ rows = [], columns = [], sx: sxProp, ...rest }) => (
	<DataGrid
		columns={columns}
		rows={rows}
		getRowId={(row) => row?.[breakdownGridRowIdKey] ?? String(row?.id)}
		pagination={false}
		sx={[getBreakdownDataGridSx(rows.length), sxProp]}
		columnHeaderHeight={BREAKDOWN_GRID_HEADER_HEIGHT}
		rowHeight={BREAKDOWN_GRID_ROW_HEIGHT}
		showCellVerticalBorder
		disableRowSelectionOnClick
		{...rest}
	/>
);

export default BreakdownDataGrid;
